/**
 * Clé de stockage du token JWT
 */
export const AUTH_TOKEN_KEY = "homeys_auth_token"

/**
 * Clé de stockage du flag admin Homeys (master password détecté).
 * Drive `actor_type` de l'enveloppe canonique du tracking V0.
 * Non sensible (write-only impact = exclusion des metrics produit).
 */
export const ADMIN_HOMEYS_KEY = "homeys_admin"

/**
 * Clé de stockage de l'identifiant de session tracking.
 * UUID généré au login, persiste pendant la session, cleared au logout.
 */
export const SESSION_ID_KEY = "homeys_session_id"
